import ChangeProposalDocument from '@payaca/components/changeProposalDocument/ChangeProposalDocument';
import * as pdfDocumentDataActions from '@payaca/store/pdfDocumentData/pdfDocumentDataActions';
import { FC, useEffect, useState, type JSX } from 'react';
import { useDispatch } from 'react-redux';
import { useIntercom } from 'react-use-intercom';

import { ChangeProposalPdfDocumentData } from '@payaca/types/changeProposalPdfDocumentTypes';
import './ChangeProposalPage.sass';

type Props = {
  previewToken: string;
  changeProposalId: number;
};

const ChangeProposalPage: FC<Props> = ({
  previewToken,
  changeProposalId,
}: Props): JSX.Element | null => {
  const dispatch = useDispatch();
  const { update } = useIntercom();
  const [changeProposalData, setChangeProposalData] =
    useState<ChangeProposalPdfDocumentData>();

  useEffect(() => {
    dispatch(
      pdfDocumentDataActions.getChangeProposalData.request(
        previewToken,
        setChangeProposalData
      )
    );

    update({
      hideDefaultLauncher: true,
    });

    return () => {
      update({
        hideDefaultLauncher: false,
      });
    };
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'previewToken', 'update', and 'dispatch'
  }, []);

  if (!changeProposalData) return null;

  return (
    <div className="pdf-change-proposal-page">
      <ChangeProposalDocument
        documentSenderContext={changeProposalData.documentSenderContext}
        changeProposals={changeProposalData.changeProposals}
        changeProposalId={changeProposalId}
        jobLineItems={changeProposalData.jobLineItems}
        customer={changeProposalData.customer}
        siteAddresses={changeProposalData.siteAddresses || []}
        acceptedJobContent={changeProposalData.acceptedJobContent}
        hideItemPrices={changeProposalData.hideItemPrices}
        hideVatBreakdown={changeProposalData.hideVatBreakdown}
        paymentSchedule={
          changeProposalData.changeProposals.find(
            (cp) => cp.id === changeProposalId
          )?.paymentSchedule
        }
      />
    </div>
  );
};

export default ChangeProposalPage;
